
define(
	'Code25.CaterpartsGlobal.Cart'
	, [
		"Utils",
		"Code25.CaterpartsGlobal.Related.View"
	]
	, function (
		Utils,
		Code25CaterpartsGlobalRelatedView
	) {
		'use strict';
		return {
			mount: function mount(container) {

				
					var CartConfirmationView = require("Cart.Confirmation.View");
					CartConfirmationView.prototype.childViews['Related.Items'] = function (options) {

						var item = options.model.get("item");

						var relateditems_detail = item.get("relateditems_detail");
						var internalid = item.get("internalid");
						var matrix_parent = item.get("matrix_parent");
						if (matrix_parent) {
							internalid = matrix_parent.get("internalid");
						}
						if (!relateditems_detail || relateditems_detail.length == 0) {

							if (matrix_parent) {
								relateditems_detail = matrix_parent.get("relateditems_detail") || [];
							}
						}


						return new Code25CaterpartsGlobalRelatedView({
							itemsIds: internalid,
							application: container,
							related: true,
							confirmation: true
						})
					};
				

			}

		}

	});
